import {put, takeEvery} from "redux-saga/effects";
import {Color} from "../../../Models/Color";
import {localStorage} from "../../../lib/storages/localStorage";
import {colorsGetError, colorsGetSuccess} from "./actions";
import * as TYPES from "./types";

export default function* colorsSagas() {
    yield takeEvery(TYPES.COLORS_GET_REQUEST, colorsGetRequest);
}

function* colorsGetRequest(action) {
    try {
        let items = [];

        if (localStorage.getItem(TYPES.COLORS_GET_REQUEST)) {
            items = localStorage.getItem(TYPES.COLORS_GET_REQUEST);
        } else {
            const response = yield Color.index({
                ...action.payload,
            });

            items = response.data.items;
            localStorage.setItem(TYPES.COLORS_GET_REQUEST, items);
        }

        const data = {
            items: items,
            pagination: {total: 0, pages: 0},
        };

        yield put(
            colorsGetSuccess({
                data,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(colorsGetError(error));
    }
}
